export default __webpack_public_path__ + "static/media/service-gratitude.88f058cb.webp";